import { useEffect, useMemo, useState } from "react";
import { useViewContext } from "@/contexts/ViewContext";

/** Aba da página: visão do profissional ou da clínica (local, não muda o ViewContext). */
export type TeleconsultoriaViewMode = "professional" | "clinic";

const CLINIC_ROLES = ["manager", "owner", "associated"];

/**
 * Permissões por aba (mesma regra do Pronto Atendimento):
 * - profissional: papel `practitioner`;
 * - clínica: `manager`, `owner` ou `associated`.
 * A aba padrão é a profissional quando permitida; o seletor só aparece com as duas.
 */
export function useTeleconsultoriaViewAccess(preferredView?: TeleconsultoriaViewMode) {
  const { availableRoles } = useViewContext();
  const roles: string[] = Array.isArray(availableRoles) ? availableRoles : [];
  const canProfessional = roles.includes("practitioner");
  const canClinic = roles.some((role) => CLINIC_ROLES.includes(role));

  const defaultView = useMemo<TeleconsultoriaViewMode>(() => {
    if (preferredView === "clinic" && canClinic) return "clinic";
    if (canProfessional) return "professional";
    if (canClinic) return "clinic";
    return "professional";
  }, [preferredView, canProfessional, canClinic]);

  const [view, setView] = useState<TeleconsultoriaViewMode>(defaultView);
  useEffect(() => {
    setView(defaultView);
  }, [defaultView]);

  return {
    view,
    setView,
    canProfessional,
    canClinic,
    hasAnyView: canProfessional || canClinic,
    showToggle: canProfessional && canClinic,
  };
}
